import { create } from "zustand"
import type { CashRecommendationState } from "./types"
import { getStoreKey } from "./types"

const useCashRecommendationStore = create<CashRecommendationState>((set, get) => ({
    byKey: {},
    setLoading: (account, eventType, key) =>
        set((state) => ({
            byKey: {
                ...state.byKey,
                [getStoreKey(account, eventType, key)]: { loading: true, error: null, data: undefined },
            },
        })),
    setResult: (account, eventType, data, key) =>
        set((state) => ({
            byKey: {
                ...state.byKey,
                [getStoreKey(account, eventType, key)]: { loading: false, error: null, data },
            },
        })),
    setError: (account, eventType, error, key) =>
        set((state) => ({
            byKey: {
                ...state.byKey,
                [getStoreKey(account, eventType, key)]: { loading: false, error, data: undefined },
            },
        })),
    getEntry: (account, eventType, key) => get().byKey[getStoreKey(account, eventType, key)],
}))

export { useCashRecommendationStore }
